module.exports = __webpack_public_path__ + "static/rn-010a08867356ac8b3cc62fea18253ca0.png";